import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { getInvoiceEffectiveStatus } from "@common/helpers/accrual-source";
import { InvoiceLineItem, InvoiceStatus } from "@common/types/invoice";
import classNames from "classnames";
import { useViewTableMeta } from "@hooks/view/useViewTableMeta";
import { InvoiceStatus as InvoiceStatusComponent } from "../../../InvoiceStatus";
import { InvoiceLineItemsViewCallbacks } from "../types";
import styles from "./StatusCell.module.scss";

export const StatusCell = memo(
    ({
        row,
        table,
        getValue,
    }: CellContext<
        ViewTableFeatures,
        InvoiceLineItem,
        InvoiceStatus | null
    >) => {
        const lineItem = row.original;
        const status =
            getValue() ??
            (lineItem.invoice
                ? getInvoiceEffectiveStatus(lineItem.invoice)
                : null);
        const { callbacks } = useViewTableMeta<
            InvoiceLineItemsViewCallbacks,
            unknown
        >(table);
        const { hasTopSibling, hasBottomSibling } = callbacks?.checkSiblings(
            lineItem,
        ) ?? {
            hasTopSibling: false,
            hasBottomSibling: false,
        };

        return (
            <ViewTableCell>
                <div className={styles.statusContent}>
                    <div
                        className={classNames(styles.statusContentContainer, {
                            [styles.statusContentContainerAdjacentSibling]:
                                hasBottomSibling,
                            [styles.statusContentContainerWithTopLine]:
                                hasTopSibling,
                        })}
                    ></div>
                    {status ? <InvoiceStatusComponent status={status} /> : null}
                </div>
            </ViewTableCell>
        );
    },
);
